export const APP_ENV = "local";
export const TTP_API_URL = `http://local.api.tamtam.pro`;
export const TTP_HOME_URL = `http://local.tamtam.pro/`;

export const CAROUSEL_DISPOSITIONS = {
  default: 1,
  type1: 3,
  type2: 2,
  type3: 2,
  type4: 3,
  type5: 2,
  type6: 3,
  type7: 2,
};

export const SOCIAL_NETWORKS_HOSTS = {
  FACEBOOK: "https://www.facebook.com",
  TWITTER: "https://www.twitter.com",
  LINKEDIN: "https://www.linkedin.com",
};
